import { useNavigate } from 'react-router-dom';
import { SignupLayout } from './Layout.tsx';

/**
 * Screen 1 — the "hand this device to a grown-up" card.
 *
 * Spec §11.3.3 calls for two CTAs here:
 *   - "I AM the grown-up" → continue to Screen 2 (provider trio)
 *   - "I'll go get one"   → terminal screen with cross-device deep link tip
 *
 * No real navigation off-canvas yet; the kid-side experience is whatever
 * was on the canvas. We close the dialog instead of "going somewhere."
 */
export function Step1Handoff(): JSX.Element {
  const navigate = useNavigate();

  return (
    <SignupLayout
      step={1}
      hideStepDots
      title="Hand this to a grown-up 🧑‍🦱"
      subtitle="To save your art and use it next time, a grown-up needs to set things up. It only takes a minute."
    >
      <div className="flex flex-col gap-3">
        <button
          type="button"
          onClick={() => navigate('/signup/2')}
          className="rounded-2xl bg-amber-500 px-6 py-4 text-lg font-semibold text-white shadow transition active:scale-95 hover:bg-amber-600"
        >
          I am the grown-up
        </button>
        <button
          type="button"
          onClick={() => navigate('/')}
          className="rounded-2xl border border-slate-200 bg-white px-6 py-4 text-base text-slate-600 transition active:scale-95 hover:bg-slate-50"
        >
          I&rsquo;ll get one — keep playing
        </button>
      </div>

      <p className="mt-6 text-xs text-slate-500">
        Your art is saved on this device until a grown-up sets up an account. After 24 hours without
        a grown-up, the device will tidy up and you&rsquo;ll start fresh.
      </p>
    </SignupLayout>
  );
}
